import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSVideoGalleryTagName: string = 'hhds-video-gallery';
const TAG_NAME: string = HHDSVideoGalleryTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSVideoGalleryAttrNames = {};

//const Attrs = HHDSVideoGalleryAttrNames;

export class HHDSVideoGallery extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = `
      <div class="${TAG_NAME}">
				<div class="${TAG_NAME}__container">
					<slot name="header"></slot>
					<div class="grid ${TAG_NAME}__outer-grid">
						<div class="${TAG_NAME}__content col-span-4 md:col-span-12 lg:col-span-16 lg:col-start-5">
							<div class="grid ${TAG_NAME}__inner-grid">
								<slot name="cards"></slot>
							</div>
						</div>
					</div>
				</div>
			</div>
    `;

		this.setInnerHtml('', '', html);
		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
